export default () => ({
  index: [],
  besteldagen: [],
  klanten: [],
});
